<template lang="pug">
v-dialog(:value="show" @input="hide" max-width="900")
  v-card(v-if="content")
    v-img(v-if="content.image" :src="content.image" :aspect-ratio="16/9")
    v-card-title.grey.lighten-4.py-0.pr-1(v-if="content.showPanelTitle")
      .title {{extra.name}}
      v-spacer
      v-btn(icon @click="hide"): v-icon close
    v-card-text(v-if="content.content" v-html="content.content" :class="padding ? '' : 'pa-0'")

</template>

<script>
export default {
  props: ['extra', 'isPage', 'menu'],
  data() {
    return {
      show: false
    }
  },
  watch: {
    content: {
      immediate: true,
      handler(content) {
        if (content && this.extra) {
          const version = localStorage.getItem(`extra.lightbox.${this.extra.id}`, this.content.version || '0')
          if (content.version != version) {
            this.show = true
          }
        }
      }
    }
  },
  computed: {
    padding() {
      return !(this.extra && this.extra.options && this.extra.options.wrapper && this.extra.options.wrapper.indexOf("box") >= 0)
    },
    content() {
      if (this.extra && this.extra.content) {
        return JSON.parse(this.extra.content)
      } else {
        return false
      }
    },
  },
  methods: {
    hide() {
      if (this.extra) {
        this.show = false
        localStorage.setItem(`extra.lightbox.${this.extra.id}`, this.content.version || '0')
      }
    }
  }
}
</script>
